import 'd3';


export default function() {
	return {
		scope: {
			data: '<',
		},
		link: link,
	};

	function link(scope, element, attrs, ctrls) {
		var hist = [];
		for (var i = 0; i < 7; i++) {
			hist[i] = scope.data[i][0];
		}

		var color = 'steelblue';

		var margin = {top: 20, right: 30, bottom: 30, left: 30},
			outerWidth = 357,
			outerHeight = 220,
			width = outerWidth - margin.left - margin.right,
			height = outerHeight - margin.top - margin.bottom;

		var x = d3.scale.linear()
			.domain([0, 7])
			.range([0, width]);

		var yMax = d3.max(hist);
		var yMin = d3.min(hist);

		var colorScale = d3.scale.linear()
			.domain([0, yMax])
			.range([d3.rgb(color).brighter(), d3.rgb(color).darker()]);

		var y = d3.scale.linear()
			.domain([0, yMax])
			.range([height, 0]);

		var svg = d3.select(element[0])
			.attr('viewBox', '0 0 ' + outerWidth + ' ' + outerHeight)
		  .attr('preserveAspectRatio', 'xMinYMin meet')
			.attr('width', '100%')
			.append('g')
			.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

		var xAxis = d3.svg.axis()
			.scale(x)
			.tickFormat(function(d, i) {
				return ['M', 'Tu', 'W', 'Th', 'F', 'Sa', 'Su'][i];
			})
			.orient('bottom');

		var yAxis = d3.svg.axis()
			.scale(y)
			.ticks(4)
			.tickSize(-width)
			.orient('left');

		svg.append('g')
			.attr('class', 'x axis')
			.attr('transform', 'translate(' + (width/14) + ' ,' + height + ')')
			.call(xAxis);

		svg.append('g')
			.attr('class', 'y axis')
			.call(yAxis);

		var bar = svg.selectAll('.bar')
			.data(hist)
			.enter().append('g')
			.attr('class', 'bar')
			.attr('transform', (d, i) => 'translate(' + x(i) + ',' + y(d) + ')');

		bar.append('rect')
			.attr('x', 2)
			.attr('width', (x(1) - x(0)) - 4)
			.attr('height', d => height - y(d))
			.attr('fill', d => colorScale(d));
	}
}
